function infinityAds()
{
    var random_num = Math.random();
    if(!(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) && random_num < .15 ){
        var cur_body_class = document.body.getAttribute('class').split(/\s+/); //grab body class

        //ONLY ON SPECIFIC SECTIONS
        if(cur_body_class[0]=='polls' || cur_body_class[0]=='video' || cur_body_class[0]=='article' || cur_body_class[0]=='home'){
                                

            window.InfPreInsterstitialProcessCallback = function(event) { 
                var target = event.target;
                window.OnClickCallback = event.target.dataset.onclick;

                var data = {
                    'ge_action' : 'Link Clicked',
                    'ge_category' : 'AdSupply',
                    'ge_label' : cur_body_class[0],
                    'ge_noninteraction' : false
                };
                send_ga_event(data);

                eval(window.OnClickCallback);
                //alert('click 1')
            };

            window.InfPostInterstitialCallback = function(event) {
                //eval(window.OnClickCallback);
                //alert('click 2');
            }; 
                    

            (function(s,o,l,v,e,d){
                if(s[o]==null&&s[l+e]){s[o]="loading";s[l+e](d,l=function(){ 
                    s[o]="complete";s[v+e](d,l,!1)},!1)}
            })(document,"readyState","add","remove","EventListener","DOMContentLoaded");

            (function(){
                var s=document.createElement("script");
                s.type="text/javascript";
                s.async=true;
                s.src="//cdn.engine.4dsply.com/Scripts/infinity.js.aspx?guid=9483dc51-8a49-444d-92b3-54b3f3d6a32b";
                s.id="infinity";
                s.setAttribute("data-guid","9483dc51-8a49-444d-92b3-54b3f3d6a32b");
                s.setAttribute("data-version","async");
                var e=document.getElementsByTagName('script')[0];
                e.parentNode.insertBefore(s,e);
            })();

            
            var data = {
                'ge_action' : 'Called Tag',
                'ge_category' : 'AdSupply',
                'ge_label' : cur_body_class[0],
                'ge_noninteraction' : true
            };

            send_ga_event(data);
        }
    }
}

export default infinityAds;